export default function AboutData() {
    return {
        title: "About Long Term Care Life Insurance",
        content:
            "Long-term care insurance is coverage for extended care, including nursing home stays and other long-term healthcare needs. With healthcare costs rising, your retirement income could be in jeopardy without proper protection. Our team of experts can find the coverage and options that work best for you and your needs.",
    }
}